import { Suspense } from 'react';
import { Motion, spring } from 'react-motion';
import { Row, Col } from 'react-bootstrap';
import {
  FaHeart,
  FaJs,
  FaCss3,
  FaHtml5,
  FaReact,
  FaNode,
} from 'react-icons/fa';
import {
  IoLogoLinkedin,
  IoLogoGithub,
  IoLogoGoogle,
  IoLogoSteam,
} from 'react-icons/io';
import { useTranslation } from 'react-i18next';

import './Section.css';

import image01 from '../img/gtri.png';
import image02 from '../img/biosero.png';
// import image03 from '../img/exonbio.png';
import image04 from '../img/oracle.png';
import image05 from '../img/ugg.png';
import image06 from '../img/tokuty.png';

import image10 from '../img/ucsd.png';
import image11 from '../img/intercultural_institute.png';

import image100 from '../img/parrot.gif';

import Tag from './Tag';
import Bullet from './Bullet';

function Section(props) {
  const { t } = useTranslation();
  let innerHtml = <div></div>;
  switch (props.type) {
    case 'intro':
      innerHtml = (
        <div className="intro center">
          <h1 className="myName">{t('intro.title')}</h1>
          <div className="intro-cont">
            {/* <span style={{fontSize: "2rem"}}>Hi. </span> */}
            <span>{t('intro.name')}</span> <br />
            <br />
            <span>
              {t('intro.education1')}
              <span style={{ color: '#006A96', fontWeight: '500' }}>
                {t('intro.education2')}
              </span>
              {t('intro.education3')}
              <br /> <br />
              {t('intro.hobbies')}
              {/* Recently, I've become interested in User Experience and Innovation. I'm excited to see what people are looking to disrupt next!  */}
            </span>
            <br /> <br />
            <div className="icon-cntr">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://steamcommunity.com/profiles/76561198221768576"
              >
                <IoLogoSteam color={'#00adee'} />
              </a>
              {/* <a target="_blank" rel="noopener noreferrer" href="https://starcraft2.com/en-us/profile/1/1/1041476">
            <FaBattleNet color={"#1e71e7"}/>
          </a> */}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/in/justin-ang/"
              >
                <IoLogoLinkedin color={'#0077b5'} />
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://github.com/justin8502"
              >
                <IoLogoGithub color={'#333'} />
              </a>
              <a href="mailto:justinang13@gmail.com">
                <IoLogoGoogle color={'#000000'} />
              </a>
            </div>
          </div>
        </div>
      );
      break;
    case 'projects':
      innerHtml = (
        <div>
          <div className="projects">
            <h1>{t('projects.title')}</h1>
            <div className="section-cont">
              <Row className="proj-entry">
                <Col sm={12} md={5} className="proj-vital">
                  <span className="title">
                    Meraki Analytics/lolstaticdata
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://github.com/meraki-analytics/lolstaticdata"
                    >
                      <IoLogoGithub />
                    </a>
                  </span>
                  <div className="proj-tags">
                    <Tag type="python" />
                    <Tag type="open-source" />
                  </div>
                </Col>
                <Col sm={12} md={7} className="proj-desc">
                  <span className="blurb">
                    {t('projects.meraki_analytics_lolstaticdata.description')}
                  </span>
                  <br />
                  <Bullet
                    text={t('projects.meraki_analytics_lolstaticdata.bullet_1')}
                  />
                  <Bullet
                    text={t('projects.meraki_analytics_lolstaticdata.bullet_2')}
                  />
                </Col>
              </Row>
              <Row className="proj-entry">
                <Col sm={12} md={5} className="proj-vital">
                  <span className="title">
                    LoL-Session
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://github.com/justin8502/lol-session"
                    >
                      <IoLogoGithub />
                    </a>
                  </span>
                  <div className="proj-tags">
                    <Tag type="electron" />
                    <Tag type="html" />
                    <Tag type="css" />
                    <Tag type="js" />
                  </div>
                </Col>
                <Col sm={12} md={7} className="proj-desc">
                  <span className="blurb">
                    {t('projects.lol_session.description')}
                  </span>
                  <br />
                  <Bullet text={t('projects.lol_session.bullet_1')} />
                  <Bullet text={t('projects.lol_session.bullet_2')} />
                  <Bullet text={t('projects.lol_session.bullet_3')} />
                </Col>
              </Row>
              <Row className="proj-entry">
                <Col sm={12} md={5} className="proj-vital">
                  <span className="title">
                    Demacia
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://github.com/justin8502/Demacia"
                    >
                      <IoLogoGithub />
                    </a>
                  </span>
                  <div className="proj-tags">
                    <Tag type="js" />
                    <Tag type="heroku" />
                  </div>
                </Col>
                <Col sm={12} md={7} className="proj-desc">
                  <span className="blurb">
                    {t('projects.demacia.description')}
                  </span>
                  <br />
                  <Bullet text={t('projects.demacia.bullet_1')} />
                </Col>
              </Row>
              <Row className="proj-entry">
                <Col sm={12} md={5} className="proj-vital">
                  <span className="title">
                    Data-Loader
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://github.com/Avid-Gaming-Esports/data-loader"
                    >
                      <IoLogoGithub />
                    </a>
                  </span>
                  <div className="proj-tags">
                    <Tag type="typescript" />
                    <Tag type="react" />
                    <Tag type="redux" />
                    <Tag type="html" />
                    <Tag type="css" />
                    <Tag type="js" />
                  </div>
                </Col>
                <Col sm={12} md={7} className="proj-desc">
                  <span className="blurb">
                    {t('projects.data_loader.description')}
                  </span>
                  <br />
                  <Bullet text={t('projects.data_loader.bullet_1')} />
                  <Bullet text={t('projects.data_loader.bullet_2')} />
                </Col>
              </Row>
              <Row className="proj-entry">
                <Col sm={12} md={5} className="proj-vital">
                  <span className="title">
                    KanbanTS
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://github.com/justinang1/KanbanTS"
                    >
                      <IoLogoGithub />
                    </a>
                  </span>
                  <div className="proj-tags">
                    <Tag type="typescript" />
                    <Tag type="react" />
                    <Tag type="redux" />
                    <Tag type="html" />
                    <Tag type="css" />
                    <Tag type="js" />
                  </div>
                </Col>
                <Col sm={12} md={7} className="proj-desc">
                  <span className="blurb">
                    {t('projects.kanban_ts.description')}
                  </span>
                  <br />
                  <Bullet text={t('projects.kanban_ts.bullet_1')} />
                  <Bullet text={t('projects.kanban_ts.bullet_2')} />
                </Col>
              </Row>
              <Row className="proj-entry">
                <Col sm={12} md={5} className="proj-vital">
                  <span className="title">TagLyne</span>
                  <div className="proj-tags">
                    <Tag type="react" />
                    <Tag type="redux" />
                    <Tag type="firebase" />
                    <Tag type="html" />
                    <Tag type="css" />
                    <Tag type="js" />
                  </div>
                </Col>
                <Col sm={12} md={7} className="proj-desc">
                  <span className="blurb">
                    {t('projects.taglyne.description')}
                  </span>
                  <br />
                  <Bullet text={t('projects.taglyne.bullet_1')} />
                  <Bullet text={t('projects.taglyne.bullet_2')} />
                </Col>
              </Row>
              <Row className="proj-entry">
                <Col sm={12} md={5} className="proj-vital">
                  <span className="title">
                    Autojam
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://github.com/justinang1/autojam"
                    >
                      <IoLogoGithub />
                    </a>
                  </span>
                  <div className="proj-tags">
                    <Tag type="bash" />
                  </div>
                </Col>
                <Col sm={12} md={7} className="proj-desc">
                  <span className="blurb">
                    {t('projects.autojam.description')}
                  </span>
                  <br />
                  <Bullet text={t('projects.autojam.bullet_1')} />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      );
      break;
    case 'job':
      innerHtml = (
        <div>
          <h1>{t('work.title')}</h1>
          <div className="section-cont">
            <Row className="work-entry">
              <Col lg={12} xl={3}>
                <img
                  src={image06}
                  alt="tokuty"
                  style={{ width: 200, margin: '16px 0px' }}
                />
              </Col>
              <Col lg={12} xl={6} className="work-desc">
                <div className="work-pos">
                  {t('work.tokuty.company')}{' '}
                  <div className="hide-on-mobile">//</div>{' '}
                  <div className="br-mobile">
                    <br />
                  </div>
                  {t('work.tokuty.title')}
                </div>
                <div className="pos-mobile">
                  <div>
                    <span className="work-duration">
                      {t('work.tokuty.duration')}
                      <br />{' '}
                    </span>{' '}
                  </div>
                  <div>{t('work.tokuty.location')}</div>
                </div>
                <Bullet text={t('work.tokuty.bullet_1')} />
                <Bullet text={t('work.tokuty.bullet_2')} />
                <Bullet text={t('work.tokuty.bullet_3')} />
              </Col>
              <Col lg={12} xl={3} className="pos-format">
                <div>
                  <span className="work-duration">
                    {t('work.tokuty.duration')}
                    <br />{' '}
                  </span>{' '}
                </div>
                <div>{t('work.tokuty.location')}</div>
              </Col>
            </Row>
            <Row className="work-entry">
              <Col lg={12} xl={3}>
                <img
                  src={image05}
                  alt="ugg"
                  style={{ width: 200, height: 100 }}
                />
              </Col>
              <Col lg={12} xl={6} className="work-desc">
                <div className="work-pos">
                  {t('work.u_gg.company')}{' '}
                  <div className="hide-on-mobile">//</div>{' '}
                  <div className="br-mobile">
                    <br />
                  </div>
                  {t('work.u_gg.title')}
                </div>
                <div className="pos-mobile">
                  <div>
                    <span className="work-duration">
                      {t('work.u_gg.duration')}
                      <br />{' '}
                    </span>{' '}
                  </div>
                  <div>{t('work.u_gg.location')}</div>
                </div>
                <Bullet text={t('work.u_gg.bullet_1')} />
                <div className="descriptor">
                  <div className="descriptor-dash">&nbsp; </div>
                  <div>{t('work.u_gg.bullet_1_5')}</div>
                </div>
                <Bullet text={t('work.u_gg.bullet_2')} />
                <Bullet text={t('work.u_gg.bullet_3')} />
                <Bullet text={t('work.u_gg.bullet_4')} />
                <Bullet text={t('work.u_gg.bullet_5')} />
              </Col>
              <Col lg={12} xl={3} className="pos-format">
                <div>
                  <span className="work-duration">
                    {t('work.u_gg.duration')}
                    <br />{' '}
                  </span>{' '}
                </div>
                <div>{t('work.u_gg.location')}</div>
              </Col>
            </Row>
            <Row className="work-entry">
              <Col lg={12} xl={3}>
                <img
                  src={image04}
                  alt="oracle"
                  style={{ width: 220, height: 40 }}
                />
              </Col>
              <Col lg={12} xl={6} className="work-desc">
                <div className="work-pos">
                  {t('work.oracle.company')}{' '}
                  <div className="hide-on-mobile">//</div>{' '}
                  <div className="br-mobile">
                    <br />
                  </div>
                  {t('work.oracle.title')}
                </div>
                <div className="pos-mobile">
                  <div>
                    <span className="work-duration">
                      {t('work.oracle.duration')}
                      <br />{' '}
                    </span>{' '}
                  </div>
                  <div>{t('work.oracle.location')}</div>
                </div>
                <Bullet text={t('work.oracle.bullet_1')} />
                <Bullet text={t('work.oracle.bullet_2')} />
                <Bullet text={t('work.oracle.bullet_3')} />
                <Bullet text={t('work.oracle.bullet_4')} />
              </Col>
              <Col lg={12} xl={3} className="pos-format">
                <div>
                  <span className="work-duration">
                    {t('work.oracle.duration')}
                    <br />{' '}
                  </span>{' '}
                </div>
                <div>{t('work.oracle.location')}</div>
              </Col>
            </Row>
            <Row className="work-entry">
              <Col lg={12} xl={3}>
                <img
                  src={image01}
                  alt="gtri"
                  style={{ width: 220, height: 50 }}
                />
              </Col>
              <Col lg={12} xl={6} className="work-desc">
                <div className="work-pos">
                  {t('work.gtri.company')}{' '}
                  <div className="hide-on-mobile">//</div>{' '}
                  <div className="br-mobile">
                    <br />
                  </div>{' '}
                  {t('work.gtri.title')}
                </div>
                <div className="pos-mobile">
                  <div>
                    <span className="work-duration">
                      {t('work.gtri.duration')}
                      <br />{' '}
                    </span>{' '}
                  </div>
                  <div>{t('work.gtri.location')}</div>
                  <div>{t('work.biosero.location')}</div>
                </div>
                <Bullet text={t('work.gtri.bullet_1')} />
                <Bullet text={t('work.gtri.bullet_2')} />
              </Col>
              <Col lg={12} xl={3} className="pos-format">
                <div>
                  <span className="work-duration">
                    {t('work.gtri.duration')}
                    <br />{' '}
                  </span>{' '}
                </div>
                <div>{t('work.gtri.location')}</div>
              </Col>
            </Row>
            <Row className="work-entry">
              <Col lg={12} xl={3}>
                <img src={image02} alt="biosero" />
              </Col>
              <Col lg={12} xl={6} className="work-desc">
                <div className="work-pos">
                  {t('work.biosero.company')}{' '}
                  <div className="hide-on-mobile">//</div>{' '}
                  <div className="br-mobile">
                    <br />
                  </div>
                  {t('work.biosero.title')}
                </div>
                <div className="pos-mobile">
                  <div>
                    <span className="work-duration">
                      {t('work.biosero.duration')}
                      <br />{' '}
                    </span>{' '}
                  </div>
                  <div>{t('work.biosero.location')}</div>
                </div>
                <Bullet text={t('work.biosero.bullet_1')} />
                <Bullet text={t('work.biosero.bullet_2')} />
                <Bullet text={t('work.biosero.bullet_3')} />
              </Col>
              <Col lg={12} xl={3} className="pos-format">
                <div>
                  <span className="work-duration">
                    {t('work.biosero.duration')}
                    <br />{' '}
                  </span>{' '}
                </div>
                <div>{t('work.biosero.location')}</div>
              </Col>
            </Row>
          </div>
        </div>
      );
      break;
    case 'education':
      innerHtml = (
        <div>
          <div className="education">
            <h1>{t('education.title')}</h1>
            <div className="section-cont">
              <Row>
                <Col lg={12} xl={3}>
                  <img
                    src={image10}
                    alt="ucsd"
                    style={{ width: 200, margin: '16px 0px' }}
                  />
                </Col>
                <Col lg={12} xl={6} className="education-desc">
                  <h2>
                    {t('education.university.name_1')}{' '}
                    <div className="br-mobile">
                      <br />
                    </div>
                    {t('education.university.name_2')}
                  </h2>
                  <h4>{t('education.university.degree')}</h4>
                  <div className="pos-mobile">
                    <div>
                      <span className="education-duration">
                        {t('education.university.duration')}
                      </span>
                    </div>
                    <div>{t('education.university.location')}</div>
                  </div>
                </Col>
                <Col lg={12} xl={3} className="pos-format">
                  <div>
                    <span className="education-duration">
                      {t('education.university.duration')}
                    </span>
                  </div>
                  <div>{t('education.university.location')}</div>
                </Col>
                <div />
              </Row>
            </div>
            <div className="section-cont">
              <Row>
                <Col lg={12} xl={3}>
                  <img
                    src={image11}
                    alt="intercultural_institute"
                    style={{ width: 180, margin: '16px 0px' }}
                  />
                </Col>
                <Col lg={12} xl={6} className="education-desc">
                  <h2>{t('education.study_abroad.name')}</h2>
                  <h4>{t('education.study_abroad.degree')}</h4>
                  <div className="pos-mobile">
                    <div>
                      <span className="education-duration">
                        {t('education.study_abroad.duration')}
                      </span>
                    </div>
                    <div>{t('education.study_abroad.location')}</div>
                  </div>
                </Col>
                <Col lg={12} xl={3} className="pos-format">
                  <div>
                    <span className="education-duration">
                      {t('education.study_abroad.duration')}
                    </span>
                  </div>
                  <div>{t('education.study_abroad.location')}</div>
                </Col>
                <div />
              </Row>
            </div>
            <div className="section-cont">
              <Row>
                <Col lg={12} xl={3}>
                  <h2>{t('education.languages.title')}</h2>
                </Col>
                <Col lg={12} xl={5} className="education-desc">
                  <h4>{t('education.languages.english.label')}</h4>
                  <br />
                  <h4>{t('education.languages.japanese.label')}</h4>
                  <div className="education-exam">
                    - {t('education.languages.japanese.exam_1.name')}
                  </div>
                  <ul>
                    <li>
                      {t('education.languages.japanese.exam_1.section_1')}
                    </li>
                    <li>
                      {t('education.languages.japanese.exam_1.section_2')}
                    </li>
                    <li>
                      {t('education.languages.japanese.exam_1.section_3')}
                    </li>
                    <li>
                      {t('education.languages.japanese.exam_1.section_total')}
                    </li>
                  </ul>
                  <br />
                </Col>
                <Col lg={12} xl={4} className="education-desc-right">
                  <h4>{t('education.languages.chinese.label')}</h4>
                  <div className="education-exam">
                    - {t('education.languages.chinese.exam_1.name')}
                  </div>
                  <ul>
                    <li>{t('education.languages.chinese.exam_1.section_1')}</li>
                    <li>{t('education.languages.chinese.exam_1.section_2')}</li>
                    <li>{t('education.languages.chinese.exam_1.section_3')}</li>
                    <li>
                      {t('education.languages.chinese.exam_1.section_total')}
                    </li>
                  </ul>
                  <br />
                </Col>
                <div />
              </Row>
            </div>
          </div>
        </div>
      );
      break;
    case 'footer':
      innerHtml = (
        <div className="footer center">
          <h1 className="end-message">
            {t('footer.thanks')}
            <div>
              <img src={image100} alt="party-parrot" className="parrot" />
              <img src={image100} alt="party-parrot" className="parrot" />
              <img src={image100} alt="party-parrot" className="parrot" />
            </div>
          </h1>
          <h3>
            <span className="heart-format">
              {t('footer.heart_1')} <FaHeart color="fd5c63" />{' '}
              {t('footer.heart_2')}
            </span>
          </h3>
          <br />
          <h4>
            ({t('footer.and')}
            <FaHtml5 color="e34f26" /> <FaCss3 /> <FaJs color="f7df1e" />{' '}
            <FaReact color="00d8ff" /> <FaNode color="215732" />)
          </h4>
        </div>
      );
      break;
    default:
  }
  return (
    <Suspense fallback={<div></div>}>
      <Motion defaultStyle={{ opacity: 0 }} style={{ opacity: spring(1) }}>
        {(style) => <div style={style}>{innerHtml}</div>}
      </Motion>
    </Suspense>
  );
}

function SectionWrapper(props) {
  return (
    <Suspense fallback={<div></div>}>
      <Section type={props.type} />
    </Suspense>
  );
}

export default SectionWrapper;
